export const unleashFlags = {
  REPORTS: 'REPORTS',
  MEDIA_EXPORT: 'MEDIA_EXPORT',
  HIDE_PLAN_EXPORT: 'HIDE_PLAN_EXPORT',
  PDF_PLAN_PREVIEW: 'PDF_PLAN_PREVIEW',
  HIDE_ASSIGN_REPORT_TEMPLATE_TO_ALL_PROJECTS:
    'HIDE_ASSIGN_REPORT_TEMPLATE_TO_ALL_PROJECTS'
}
